/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './updateAllRead.defs'
export { main as default } from './updateAllRead.defs'
